import React, { useMemo } from 'react';
import { ModuleWithImage } from '../module-with-image';
import type { IPropsWithTestId } from '../../../../constants/data-element-tracking-ids';
import { DataElementId } from '../../../../constants/data-element-tracking-ids';
import HomepageModuleWrapper from '../homepage-module-wrapper/homepage-module-wrapper';
import type { IModuleWithImageData } from '../../../../dotcms/dotcms-models/dotcms-module-with-image';
import { Page } from '../../../../app/page-url-path';
import { ButtonVariant } from '../../../../component_library/components/Button';
import { OperationButton } from '../../../OperationButton';
import { useOperationButton } from '../../../OperationButton/hook';

interface IProps {
  data: IModuleWithImageData;
}

const WelcomeModule: React.FC<IProps> = ({ data }) => {
  const { action } = useOperationButton();

  const renderButtonElement = useMemo(
    () =>
      (action
        ? (
          props: IPropsWithTestId & {
            label: string | undefined;
            buttonVariant: ButtonVariant;
          },
        ) => (
          <OperationButton
            dataElementId={props.dataElementId}
            variant={props.buttonVariant}
            label={props.label}
          />
        )
        : undefined),
    [action],
  );

  return (
    <HomepageModuleWrapper dataComponentName="WelcomeModule">
      <ModuleWithImage
        data={data}
        renderButtonElement={renderButtonElement}
        button={{
          pageForButton: {
            defaultData: Page.ENROLLMENT_PAGE,
            ifEnrollmentIsAvailableData: Page.ENROLLMENT_PAGE,
            ifInEsppButNotInCashless: Page.ENROLLMENT_PAGE,
          },
          dataElementId: DataElementId.HOMEPAGE_LINK_WELCOME_ENROLL_CTA,
          buttonVariant: ButtonVariant.PRIMARY,
        }}
      />
    </HomepageModuleWrapper>
  );
};

export default WelcomeModule;
